import { createSlice } from '@reduxjs/toolkit';

export const user = createSlice({
  name: 'user',
  initialState: {
    token: '',
  },
  reducers: {
    setToken: (state, action) => {
      // console.log("Action Payload:", action.payload);
      state.token = action.payload;
    },
  },
});

export const { setToken, token } = user.actions;

export default user.reducer;
